import { Notify } from 'quasar';
export default {
  methods: {
    showError (text, time = 2000) {
      this.$q.notify({
        message: text,
        color: 'red',
        icon: 'warning',
        timeout: time
      });
    },
    showMessage (text, time = 600) {
      this.$q.notify({
        message: text,
        color: 'secondary',
        icon: 'done',
        timeout: time
      });
    }
  },
  showError (text, time = 2000) {
    Notify.create({
      message: text,
      color: 'red',
      icon: 'warning',
      timeout: time
    });
  },
  showMessage (text, time = 600) {
    Notify.create({
      message: text,
      color: 'secondary',
      icon: 'done',
      timeout: time
    });
  }
};
